// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"419":"3dd29fcd","579":"5e85c1b1","681":"7b1ff10b"}[chunkId] + ".chunk.js";
};